import { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { GeneralDropdown } from "../../../../components/components/js/GeneralDropdown";
import { downloadPDF } from "../../../../utils/exportUtils";
import { StaffIndividualAttendance } from "./StaffIndividualAttendance";
import { StaffAllAttendance } from "./StaffAllAttendance";
import { useTranslation } from "react-i18next";

export const StaffAttendanceReport = () => {
  const { t } = useTranslation();
  const trans_prefix = "admin_pages.attendance_reports";
  const trans = {
    title: t("admin_titles.staff_attendance_report"),
    export_pdf: t("buttons.export_pdf"),
   
    staff_individual: t(`${trans_prefix}.report_types.staff_individual`),
    staff_all: t(`${trans_prefix}.report_types.staff_all`),
  };

  const reportTypes = [
   
    { value: "staff_individual", label: trans.staff_individual },
    { value: "staff_all", label: trans.staff_all },
  ];

  const getInitialReportType = () => {
    const hash = window.location.hash.replace("#", "");
    return reportTypes.find((r) => r.value === hash) || reportTypes[0];
  };

  const [selectedReportType, setSelectedReportType] = useState(getInitialReportType);
  const staffIndividualRef = useRef();
  const staffAllRef = useRef();

  const handleReportTypeChange = (option) => {
    setSelectedReportType(option);
    window.location.hash = option.value;
  };

  const handleDownloadPDF = () => {
    let element;
    switch (selectedReportType.value) {
      case "staff_individual":
        element = staffIndividualRef.current;
        break;
      case "staff_all":
        element = staffAllRef.current;
        break;
      default:
        break;
    }
    if (element) downloadPDF(element);
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center py-4">
        <div className="d-flex gap-4">
          <h3>{trans.title}</h3>
          <GeneralDropdown
            placeholder={"Report Type"}
            options={reportTypes}
            selectedOption={selectedReportType}
            onChange={handleReportTypeChange}
            backgroundColor={"#eee"}
            width={"11rem"}
            noBorder
          />
        </div>
        <Button
          onClick={handleDownloadPDF}
          className="fw-bold purple-text-color bg-transparent border-0 no-hover-bg"
        >
          {trans.export_pdf}
        </Button>
      </div>

      {selectedReportType.value === "staff_individual" ? (
        <StaffIndividualAttendance reportRef={staffIndividualRef} />
      ) : (
        <StaffAllAttendance reportRef={staffAllRef} />
      )}
    </>
  );
};